import React, { useState, useEffect } from 'react';
import { Anchor, Drawer, Button } from 'antd';
import SmallLogo from './SmallLogo';
import { CloseOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';
const { Link } = Anchor;

const navItems = [
  { href: '#hero',    label: 'Home' },
  { href: '#about',   label: 'About' },
  { href: '#feature', label: 'Features' },
  { href: '#tools',   label: 'Tools' },
  { href: '#works',   label: 'How it works' },
  { href: '#faq',     label: 'FAQ' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#contact', label: 'Contact' },
];

function useActiveAnchor() {
  const [active, setActive] = useState('#hero');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY < 100) {
        setActive('#hero');
        return;
      }
      const ids = navItems.map(n => n.href);
      for (let i = ids.length - 1; i >= 0; i--) {
        const el = document.querySelector(ids[i]);
        if (el && el.getBoundingClientRect().top <= window.innerHeight * 0.4) {
          setActive(ids[i]);
          return;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return active;
}

function NavLinks({ active, onClick }) {
  return (
    <ul className='custom-nav'>
      {navItems.map(({ href, label }) => (
        <li key={href} className={active === href ? 'custom-nav-item active' : 'custom-nav-item'}>
          <a href={href} onClick={onClick}>{label}</a>
        </li>
      ))}
    </ul>
  );
}

function AppHeader() {
  const [visible, setVisible] = useState(false);
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  const active = useActiveAnchor();

  return (
    <div className='container-fluid'>
      <div className='header'>
        <div className='logo'>
          <SmallLogo />
          &emsp;&emsp;
          {!isMobile && <a href='#hero'>Desi8n</a>}
        </div>
        <div className='mobileHidden'>
          <NavLinks active={active} />
        </div>
        <div className='mobileVisible'>
          <Button type='primary' onClick={() => setVisible(true)}>
            <i className='fas fa-bars'></i>
          </Button>
          <Drawer
            placement='right'
            onClose={() => setVisible(false)}
            open={visible}
            width='50%'
            closeIcon={<CloseOutlined style={{ marginLeft: '-12px' }} />}
          >
            <Anchor targetOffset='65' onClick={() => setVisible(false)}>
              <Link href='#hero' title='Home' />
              <Link href='#about' title='About' />
              <Link href='#feature' title='Features' />
              <Link href='#tools' title='Tools' />
              <Link href='#works' title='How it works' />
              <Link href='#faq' title='FAQ' />
              <Link href='#pricing' title='Pricing' />
              <Link href='#contact' title='Contact' />
            </Anchor>
          </Drawer>
        </div>
      </div>
    </div>
  );
}

export default AppHeader;
